import React, { useCallback, useEffect, useMemo } from 'react'
import { Form, Row, Spin } from 'antd'
import { isEmpty } from 'lodash'

import {
  DirtyPromptForm,
  FormButtons,
  FormImageUpload,
} from '../../../common/components/sections'
import { PERMISSIONS } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useFormDirty, useUserHasPermissions } from '../../../common/hooks'

import { useUpdateChallengeImageDetailsMutation } from '../../hooks'
import { challengePropType } from '../../prop-types'

import { challengeImageFormInitialValues } from './initial-values'

const ChallengeImageDetailsForm = ({ challenge }) => {
  // const dispatch = useDispatch()

  const [form] = Form.useForm()

  const isFormEnabled = useUserHasPermissions([
    PERMISSIONS.CHALLENGE.UPDATE_IMAGE_DETAILS,
  ])

  const [
    updateChallengeImageDetails,
    { isLoading: isSaveLoading, error: saveError },
  ] = useUpdateChallengeImageDetailsMutation()

  const initialValues = useMemo(
    () => challengeImageFormInitialValues(challenge),
    [challenge],
  )

  const { isDirty, setToDirty, resetForm } = useFormDirty(form)

  const handleSaveData = useCallback(
    data => updateChallengeImageDetails(challenge.id, data),
    [challenge.id, updateChallengeImageDetails],
  )

  useEffect(() => {
    if (saveError) {
      showErrorNotification({
        title: 'Challenge details error',
        description: saveError,
      })
    }
  }, [saveError])

  // useEffect(() => {
  //   dispatch(setChallengePageIsDirty({ isImageDetailsLoading: isDirty }))
  // }, [dispatch, isDirty])

  useEffect(() => {
    resetForm()
  }, [challenge.imageUrl, resetForm])

  return isSaveLoading || isEmpty(initialValues) ? (
    <Spin />
  ) : (
    <>
      <DirtyPromptForm
        isDirty={isDirty}
        form={form}
        initialValues={initialValues}
        name="challengeImageForm"
        onFinish={handleSaveData}
        autoComplete="off"
        onFieldsChange={setToDirty}
      >
        <Row>
          <FormImageUpload
            disabled={!isFormEnabled}
            labelAbove
            name="image"
            label="Image"
          />
        </Row>
        <FormButtons
          permissions={[PERMISSIONS.CHALLENGE.UPDATE_IMAGE_DETAILS]}
          isDisabled={!isDirty}
          onReset={resetForm}
        />
      </DirtyPromptForm>
    </>
  )
}

ChallengeImageDetailsForm.propTypes = {
  challenge: challengePropType.isRequired,
}

export default ChallengeImageDetailsForm
